export default {
    expertList: [
        {
            "id": 20913,
            "name": '丁国芳',
            "imgUrl": require('@/assets/images/bjDoctor/dingguofang.png'),
            "info": "毕业于首都医科大学儿科系，长期工作在临床一线，从事儿科临床医疗和科研工作，现任中华儿科医学会儿科分会新生儿学组委员。",
            "hospital": "北京协和医院儿科",
            "post": ""
        }, {
            "id": 20915,
            "name": '李在玲',
            "imgUrl": require('@/assets/images/bjDoctor/lizailing.png'),
            "info": "中华医学会儿科分会第十四、第十六届消化学组副组长，中华医学会肠内外营养分会第四届儿科学组委员。",
            "hospital": "北京大学第三医院",
            "post": ""
        },
        {
            "id": 20902,
            "name": '史亦丽',
            "imgUrl": require('@/assets/images/bjDoctor/shiyili.png'),
            "info": "拥有30余年药房工作经验，在患者用药咨询、安全用药、医院制剂、制剂质量控制等方面具有丰富的实践经验。",
            "hospital": "北京协和医院",
            "post": "药剂科主任医师"
        },
        {
            "id": 20887,
            "name": '王琳',
            "imgUrl": require('@/assets/images/bjDoctor/wanglin.png'),
            "info": "从业近20年，擅长新生儿护理、营养、生长发育、呼吸系统和消化系统疾病等。2019年曾被授予“国之名医”荣誉称号。",
            "hospital": "首都儿科研究所",
            "post": "保健科主任"
        },
        {
            "id": 20884,
            "name": '罗莉漫',
            "imgUrl": require('@/assets/images/bjDoctor/luoliman.png'),
            "info": "儿科医生，医学博士， 哈佛医学院儿科学教授和哈佛大学陈氏公共卫生学院营养系教授，哈佛大学公共卫生学院的公共卫生硕士。",
            "hospital": "航空总医院",
            "post": "儿科病房主任"
        },
        {
            "id": 20899,
            "name": '梁芙蓉',
            "imgUrl": require('@/assets/images/bjDoctor/liangfurong.png'),
            "info": "从事儿童营养与发育咨询工作已30余年，在婴幼儿喂养及儿童膳食指导，儿童成长发育领域拥有丰富的临床经验。",
            "hospital": "北京大学第一医院",
            "post": "儿科主任医师"
        },
        {
            "id": 20896,
            "name": '席雪',
            "imgUrl": require('@/assets/images/bjDoctor/xixue.png'),
            "info": "原东城区妇幼保健院妇产科护士长，健康教育科科长，从事妇幼工作39年。知名母婴护理专家，北京市市级讲师，国家级师资培训讲师。",
            "hospital": "中国儿童少年健康基金会项目专家",
            "post": ""
        },

        {
            "id": 20881,
            "name": '孙静',
            "imgUrl": require('@/assets/images/bjDoctor/sunjing.png'),
            "info": "儿科医生，医学博士， 哈佛医学院儿科学教授和哈佛大学陈氏公共卫生学院营养系教授，哈佛大学公共卫生学院的公共卫生硕士。",
            "hospital": "北京协和医院",
            "post": "儿科护士长 副主任护师"
        },
        {
            "id": 20893,
            "name": '窦攀',
            "imgUrl": require('@/assets/images/bjDoctor/doupan.png'),
            "info": "擅长营养评价与营养管理等领域。曾获2017年度中国营养风云榜先进临床营养工作者，任2018年第四届“全民营养周”健康形象大使。",
            "hospital": "北京大学第一医院",
            "post": "临床营养科副主任医师"
        },
        {
            "id": 20890,
            "name": '张峰',
            "imgUrl": require('@/assets/images/bjDoctor/zhangfeng.png'),
            "info": "从事儿童保健工作近30年。擅长小儿生长发育，儿童营养，免疫接种，婴幼儿日常护理以及健康教育等与儿童保健相关的内容。",
            "hospital": "北京儿童医院",
            "post": "儿童保健中心主任医师"
        },
        {
            "id": 20908,
            "name": '刘燕萍',
            "imgUrl": require('@/assets/images/bjDoctor/liuyanping.png'),
            "info": "从医30余年，在孕期营养评价与营养管理，肾脏疾病、代谢性疾病营养治疗等领域具有丰富经验。",
            "hospital": "北京协和医院",
            "post": "临床营养科副主任医师"
        },
        {
            "id": 20905,
            "name": '梁爱民',
            "imgUrl": require('@/assets/images/bjDoctor/liangaimin.png'),
            "info": "擅长于儿童保健问题及常见儿科疾病，儿童发育行为与心理咨询，智能发育及儿童喂养与营养，亲子关系与家庭治疗等领域。",
            "hospital": "北京儿童医院",
            "post": "儿童保健中心主任"
        }

    ]
}